


























































































































import Vue from "vue"
import { PickupData } from "@/model/entity/collection-request/pickup-data"
import { CollectionRequest } from "@/model/entity/collection-request/collection-request"
import * as _ from "lodash"
import moment from "moment"

const currentDate = new Date()
const currentMoment = moment(currentDate)
const currentHour = currentMoment.hour()
const earliestPickup = currentMoment.add(currentHour <= 20 ? 1 : 2, "days")

export interface IPickupDataForm extends Vue {
  pickupDate: Date
  datePickerOptions: any
  sameWeight: boolean
  parcelWeight: number
  parcelWeightArray: number[]

  clearAll(): void
}

export default Vue.extend({
  data() {
    return {
      pickupDate: earliestPickup.toDate(),
      datePickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time: Date) {
          const value = moment(time)
          return moment(value).isBefore(earliestPickup.startOf("day"))
        }
      },
      sameWeight: false,
      parcelWeight: 0,
      parcelWeightArray: [0],
      rules: {
        info1: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ],
        info2: [
          {
            max: 35,
            message: `${this.$t("user_administration.max")} 35 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          }
        ]
      }
    }
  },
  props: {
    pickupData: {
      type: Object as () => PickupData,
      required: true
    },
    colReq: {
      type: Object as () => CollectionRequest,
      required: true
    },
    parcelNumber: {
      type: Number,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hasProductVariant: {
      type: Boolean,
      required: true
    },
    readOnlyParcelWeight: {
      type: String
    },
    pickupDataFormValid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    clearAll() {
      this.parcelWeight = 0.0
      this.parcelWeightArray = [0]
      this.sameWeight = false
      this.pickupDate = earliestPickup.toDate()
    },
    emitValidation() {
      const vm = this as any
      vm.$refs.form.validate(valid => {
        this.$emit("update:pickupDataFormValid", valid)
      })
    }
  },
  watch: {
    parcelNumber: {
      handler(newVal: number) {
        this.parcelWeightArray = this.parcelWeightArray.splice(newVal)
        for (let index = 0; index < this.parcelNumber; index++) {
          if (!exists(this.parcelWeightArray[index])) {
            this.parcelWeightArray[index] = 0
          }
        }
      }
    },
    parcelWeight: {
      handler(newVal: number) {
          this.pickupData.parcelWeight = 0
          this.pickupData.parcelWeight = newVal * this.parcelNumber

      }
    },
    parcelWeightArray: {
      handler(newVal: number[]) {
          this.pickupData.parcelWeight = 0
          this.pickupData.parcelWeight = _.sum(newVal)
      }
    },
    pickupData: {
      deep: true,
      handler() {
        this.emitValidation()
      }
    }
  },
  created() {
    if (exists(this.pickupData)) {
      this.pickupDate = new Date(this.pickupData.pickupDate!)
    }
  },
  mounted() {
    this.emitValidation()
  }
})
